<template>
  <mdb-container class="mt-5 content-area mt-5">
    <PageHeader text="FAQ"></PageHeader>
    <div class="row mt-5 faq">
      <div class="col-md-6">
        <FaqItem
          question="What does virallyze do?"
          answer="It helps you search, find & analyze viral content of business accounts on instagram. "
        ></FaqItem>
        <FaqItem
          question="Is Virallyze really for free?"
          answer="After registration you will receive some tokens. You can use this tokens to test virallyze for free."
        ></FaqItem>
        <FaqItem
          question="Do you have a referral program? "
          answer="No, currently not. "
        ></FaqItem>
      </div>
      <div class="col-md-6">
        <FaqItem
          question="Who uses virallyze?"
          answer="Virallyze is used by privat people, brands, agencies, influencers and us, because we try to improve it again and again. "
        ></FaqItem>
        <FaqItem
          question="How do I contact virallyze for any support? "
          answer="If you are currently a user, we will answer your mail within a short period of time and in several languages, e.g. German and English. Contact us through info@virallyze.com or use our contact form."
        ></FaqItem>
        <FaqItem
          question="How virallyze will develop in future?"
          answer="We will work on features and are always open for suggestions to make your life easier with new features. Let us know about your issues!"
        ></FaqItem>
      </div>
    </div>
  </mdb-container>
</template>

<script>
// @ is an alias to /src
import { mdbContainer } from "mdbvue";
import PageHeader from "@/components/PageHeader";
import FaqItem from "@/components/FaqItem";
export default {
  name: "FAQ",
  components: {
    mdbContainer,
    PageHeader,
    FaqItem,
  },
  data() {
    return {
      panesLeft: [
        {
          title: "Collapsible Group Item #1",
          content: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
                      3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                      Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
                      Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                      Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable.`,
        },
        {
          title: "Collapsible Group Item #2",
          content: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
                      3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                      Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
                      Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                      Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable.`,
        },
        {
          title: "Collapsible Group Item #3",
          content: `Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid.
                      3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.
                      Brunch 3 wolf moon tempor, sunt aliqua put a bird on it squid single-origin coffee nulla assumenda shoreditch et.
                      Nihil anim keffiyeh helvetica, craft beer labore wes anderson cred nesciunt sapiente ea proident. Ad vegan excepteur butcher vice lomo.
                      Leggings occaecat craft beer farm-to-table, raw denim aesthetic synth nesciunt you probably haven't heard of them accusamus labore sustainable.`,
        },
      ],
    };
  },
};
</script>
